import { consoleLogger } from '@shared/logging/consoleLogger';
import { UtiqEvents } from '@shared/events/events';
import { Environments } from '@shared/environment/environments';
import { addEventListener } from '@shared/api/sharedAPIEventFunctions';

export const registerEventListeners = (environment, listeners) => {
  if (
    typeof environment !== 'string' ||
    !Object.keys(Environments).includes(environment)
  ) {
    consoleLogger.logDebug(
      `No environment with a name "${environment}" found. Cannot register event listeners for it.`,
    );
    return;
  }
  if (
    !listeners ||
    typeof listeners !== 'object' ||
    Object.keys(listeners).length === 0
  ) {
    consoleLogger.logDebug(
      `No listeners to register for listeners object: ${listeners}`,
    );
    return;
  }

  // TODO: Post-separation refactor required https://utiq.atlassian.net/browse/UPDS-771
  const eventsEnvironment = UtiqEvents;

  Object.entries(listeners).forEach(([eventName, callback]) => {
    if (Object.keys(eventsEnvironment).includes(eventName)) {
      if (typeof callback === 'function') {
        addEventListener(eventName, callback);
      } else if (Array.isArray(callback)) {
        callback.forEach((callbackElement) => {
          if (typeof callbackElement === 'function') {
            addEventListener(eventName, callbackElement);
          } else {
            consoleLogger.logWarn(
              `Listener callback from provided callbacks array for event with name ${eventName} was not a function. Cannot register this listener. Skipping...`,
            );
          }
        });
      } else {
        consoleLogger.logWarn(
          `Listener for event with name ${eventName} was not a function, nor an array of functions. Cannot register this listener. Skipping...`,
        );
      }
    } else {
      consoleLogger.logInfo(
        `Event with name ${eventName} was not recognized. Cannot register this listener. Skipping...`,
      );
    }
  });
};
